<section class="py-24 bg-[#0a0a0f] text-white relative">
	<!-- Grid Pattern -->
	<div
		class="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_80%)]"
	></div>

	<div class="container mx-auto px-6 max-w-7xl relative z-10">
		<div class="text-center mb-20">
			<h2 class="text-4xl md:text-5xl font-bold mb-6">
				The Complete <span class="text-neon-cyan">Solution</span>
			</h2>
			<p class="text-xl text-gray-400 max-w-2xl mx-auto">
				Everything you need to build and run production systems, all in
				one place.
			</p>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
			<!-- Card 1 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-primary/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(124,58,237,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🏗️
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-primary-300 transition-colors"
				>
					Backend Architecture
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Scalable, cloud-native infrastructure with microservices,
					caching, queues, and databases auto-configured for your
					needs.
				</p>
			</div>

			<!-- Card 2 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-neon-cyan/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,242,234,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-neon-cyan/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🎨
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-neon-cyan transition-colors"
				>
					Frontend Interface
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Beautiful, responsive user interfaces optimized for your
					operations. Mobile-first design.
				</p>
			</div>

			<!-- Card 3 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-purple-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(168,85,247,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🗄️
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-purple-300 transition-colors"
				>
					Data Architecture
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Optimized database schemas, relationships, and indexing for
					performance at any scale.
				</p>
			</div>

			<!-- Card 4 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-blue-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(59,130,246,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🔌
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-blue-300 transition-colors"
				>
					API & Integrations
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Complete REST/GraphQL APIs. Pre-built connectors to 100+
					external services.
				</p>
			</div>

			<!-- Card 5 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-emerald-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(16,185,129,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🔒
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-emerald-300 transition-colors"
				>
					Security & Compliance
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Built-in encryption, RBAC, audit logging. Automatic
					compliance with GDPR, HIPAA, SOC2.
				</p>
			</div>

			<!-- Card 6 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-pink-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(236,72,153,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-pink-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					📊
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-pink-300 transition-colors"
				>
					Monitoring & Analytics
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					24/7 performance monitoring, anomaly detection, and
					automated alerting configured out of box.
				</p>
			</div>

			<!-- Card 7 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-orange-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(249,115,22,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					📝
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-orange-300 transition-colors"
				>
					Documentation
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					API documentation, deployment guides, architecture diagrams,
					all auto-generated and always up-to-date.
				</p>
			</div>

			<!-- Card 8 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-indigo-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(99,102,241,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-indigo-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🚀
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-indigo-300 transition-colors"
				>
					Deployment & CI/CD
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					One-click deployment to AWS, Azure, GCP, or on-premises.
					Automatic health checks and rollbacks.
				</p>
			</div>

			<!-- Card 9 -->
			<div
				class="group p-8 rounded-2xl bg-[#13131f] border border-white/5 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(234,179,8,0.2)]"
			>
				<div
					class="w-12 h-12 rounded-xl bg-yellow-500/10 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform"
				>
					🤖
				</div>
				<h3
					class="text-xl font-bold mb-3 text-white group-hover:text-yellow-300 transition-colors"
				>
					AI Operations
				</h3>
				<p
					class="text-gray-400 leading-relaxed group-hover:text-gray-300"
				>
					Continuous optimization, self-healing, predictive
					maintenance, and cost optimization all automated.
				</p>
			</div>
		</div>
	</div>
</section>
